import React from "react";
import "./PrevDisplay.scss";
export default function PrevDisplay(props) {
  return <div className="input">{props.data}</div>;
}
